import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';

import { Dictionaries } from '@/api/dictionaries/types';
import { DOSAGE_UNIT_LABELS } from '@/shared/pharmacy/enum';
import { DAYS_OF_WEEK_LABELS } from '@/shared/vaccination/enums';
import { dictToOptions, enumToOptions } from '@/utils/utils';

export const addSchema = (
  dictionaries?: Dictionaries,
  isEditing = false,
): IFormItem[] => [
  {
    label: 'Вид исследования, обработки и прививки',
    placeholder: 'Выберите вид исследования',
    key: 'researchTypeId',
    type: 'autocomplete',
    payload: {
      options: dictToOptions(dictionaries?.RESEARCH_TYPE),
    },
    validation: [Validators.required()],
  },
  {
    label: 'Возраст (дней)',
    placeholders: ['От', 'До'],
    key: 'age',
    type: 'numberRange',
  },
  {
    label: 'День недели',
    placeholder: 'Выберите день недели',
    key: 'daysOfWeek',
    type: 'select',
    payload: {
      mode: 'multiple',
      options: enumToOptions(DAYS_OF_WEEK_LABELS),
    },
  },
  {
    label: 'Препарат',
    placeholder: 'Выберите препарат',
    key: 'drugId',
    type: 'select',
    payload: {
      options: dictToOptions(dictionaries?.DRUG),
    },
  },
  {
    label: 'Способ введения',
    placeholder: 'Выберите способ введения',
    key: 'administrationRouteIds',
    type: 'select',
    payload: {
      mode: 'multiple',
      options: dictToOptions(dictionaries?.ADMINISTRATION_ROUTE),
    },
  },
  {
    label: 'Сдвиг мероприятия при болезни',
    key: 'isSickDelay',
    type: 'radioGroup',
    payload: {
      direction: 'horizontal',
      options: [
        { value: true, label: 'Есть' },
        { value: false, label: 'Нет' },
      ],
    },
    validation: [Validators.required()],
  },
  {
    label: 'Минимальный процент использования тары (%)',
    key: 'minPackageThreshold',
    placeholder: 'Введите процент',
    type: 'number',
    payload: {
      max: 100,
    },
    validation: [Validators.integerFrom0To100()],
  },
  {
    label: 'Не назначать животным, уже превысившим верхнюю границу возраста',
    key: 'excludeIndividualsOverageAtCreation',
    type: 'radioGroup',
    disabled: isEditing,
    payload: {
      direction: 'horizontal',
      options: [
        { value: true, label: 'Да' },
        { value: false, label: 'Нет' },
      ],
    },
    validation: [Validators.required()],
  },
];

export const addDosageSchema: IFormItem[] = [
  {
    label: 'Единица дозировки',
    placeholder: 'Выберите единицу дозировки',
    key: 'dosageUnit',
    type: 'select',
    payload: {
      options: enumToOptions(DOSAGE_UNIT_LABELS),
    },
  },
  {
    label: 'Дозировка',
    placeholders: ['От ', 'До ', 'На (кг)'],
    key: 'dosage',
    type: 'numberRangeExtra',
    payload: {
      extraPath: 'dosageWeight',
    },
  },
];
